/**
 * Determine if all elements of an array are equal, using strict equality operator.
 *
 * @param arr
 * @returns
 */
const allEqual = (arr) => arr.every((v) => v === arr[0]);

export default allEqual;
